<template>
  <div>
    <!-- 平均分摊 -->
    <el-button-group style="margin-bottom: 2px;">
      <el-button size="mini" @click="del">移除</el-button>
      <el-button size="mini" @click="houseList">按房间</el-button>
      <el-button size="mini" @click="meterList">按仪表</el-button>
    </el-button-group>
    <v-divider></v-divider>
    <el-table ref="multipleTable" :data="tableData" height="500" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection"  width="55"></el-table-column>
        <el-table-column label="收费对象" width="200">
          <template slot-scope="scope">
            <el-button style="margin-left: 3px;" @click="updatesc(scope.$index)">对象</el-button>
            {{scope.row.cname}}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="所在房间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="meter_name" label="仪表编号" width="120"></el-table-column>
        <el-table-column label="承担比率" width="120">
          <template slot-scope="scope">{{ scope.row.Rate }}</template>
        </el-table-column>
        <el-table-column prop="name" label="比率表达式" width="120">
          <template slot-scope="scope">{{scope.row.numerator}}/{{scope.row.denominator}}</template>
        </el-table-column>
        <el-table-column label="备注" width="180">
          <template slot-scope="scope">
            <el-input v-model="tableData[scope.$index].remark" placeholder="备注"></el-input>
          </template>
        </el-table-column>
    </el-table>
    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {
        house: String,
        activeName:String,
        setup_list:{}
      },
      watch:{
        "house"(){
          if(this.activeName == 'average'){
            // console.log(this.house);
            // console.log(this.activeName);
          }
        },
        "activeName"(){
          if(this.activeName == 'average'){
            // console.log(this.house);
            // console.log(this.activeName);
          }
        }
      },
      data () {
        return {
          modal1:false,
          user:[],
          projecta:[],
          tableData: [],
          multipleSelection:[],
          index:'',
        }
      },
      mounted(){
        //点击设置进来加载
        if(this.activeName == 'average'){
          // console.log(this.activeName);
          // console.log(this.setup_list);
        }
      },
      //事件
      methods: {
        datas(data){
          this.tableData = data;
        },
        //选择客户
        updatesc(index){
          this.index = index;
          this.modal1 = true;
        },
        roomUser(){
          let developer = this.$refs.child.getUser();
          this.tableData[this.index].cid = developer.id;
          this.tableData[this.index].cname = developer.name;
          //console.log(developer);
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        //点击树调用方法
        getTreeUser(tree_str){
          let user_id = this.user_id();
          let data = {'house':tree_str,'type':this.activeName,'pid':this.setup_list.project_id,'user_id':user_id,'name_type':this.setup_list.name_type,'type':2};
          let _this = this;
          ERP.showLoading()
          _this.$myhttp.post('admin/ShareSetup/user',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              let data = backdata.data.data;
              data.map(req=>{
                _this.tableData.unshift(req);
              })
              if(data.length>0){
                _this.tableData.map((it,index)=>{
                  _this.tableData[index].denominator = data[0].denominator;
                  _this.tableData[index].Rate = data[0].Rate;
                })
              }
              ERP.hideLoading()
          });
        },
        //返回数据
        getUser(){
          return this.user_id();
        },
        //选择的用户筛选出id
        user_id(){
          // console.log(this.tableData);
          return this.tableData
          // return this.tableData.map(req=>{return req.id}).join(',');
        },
        //移除
        del(){
          let _this = this;
          let data = [];
          if(_this.tableData.length == _this.multipleSelection.length){
            _this.tableData = [];
            _this.multipleSelection = [];
          }else{
            _this.tableData.map(req=>{
              let bool = true;
              _this.multipleSelection.map(reqs=>{
                if(req.id == reqs.id){
                  bool = false;
                }
              })
              if(bool){
                data.push(req);
              }
            })
          }
          _this.tableData = data;
        },
        //按房间
        houseList(){
          ERP.showLoading()
          this.$myhttp.post('admin/ShareSetup/houseList',this.tableData,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              let data = backdata.data.data;
              this.tableData = data;
              ERP.hideLoading()
          });
        },
        //按仪表
        meterList(){
          ERP.showLoading()
          this.$myhttp.post('admin/ShareSetup/meterList',this.tableData,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              let data = backdata.data.data;
              this.tableData = data;
              ERP.hideLoading()
          });
        }
      },
      components: {
        "room-user": () => import('../../../Common/room-user.vue')
      },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/share/common/average.vue